import React, { useState, useEffect } from "react";
import Projects from '../../components/Projects/Projects';


export default (props) => {
  return (
    <Projects borderCard={true} {...props} />
  )
}